// extracted by mini-css-extract-plugin
export default {"title":"portfolio_title__A0zTL"};